// Dependency: linkifyjs (https://github.com/SoapBox/linkifyjs/)

import linkifyjs from 'linkifyjs/html'

export default function (str) {

  // check for <a> and append for all found 'target="_blank"'
  str = str ? str.replace(/<a\s+href=/gi, '<a target="_blank" href=') : ''

  // outline with <a target="_blank"> any found URL or email
  return linkifyjs(str, {
    defaultProtocol: 'https'
  });
}
